import { render, staticRenderFns } from "./bloodOxygen.vue?vue&type=template&id=76dec518"
import script from "./bloodOxygen.vue?vue&type=script&lang=js"
export * from "./bloodOxygen.vue?vue&type=script&lang=js"
import style0 from "./bloodOxygen.vue?vue&type=style&index=0&id=76dec518&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports